import { ConstantValues } from "common/constants";
import { ICategory } from "models/ICategory";
import { IUseCase } from "models/IUseCase";
import { TabValues } from "./editDialog/EditUseCasePrompt.types";

export const saveSortPreference = (
  cacheKey: string,
  columnKey: string,
  descending: boolean,
): void => {
  const savedSortingOptions = localStorage.getItem(
    ConstantValues.SORTING_OPTIONS_CACHE_KEY,
  );
  const sortingOptions = savedSortingOptions
    ? JSON.parse(savedSortingOptions)
    : {};

  sortingOptions[cacheKey] = {
    column: columnKey,
    direction: descending ? "desc" : "asc",
  };

  localStorage.setItem(
    ConstantValues.SORTING_OPTIONS_CACHE_KEY,
    JSON.stringify(sortingOptions),
  );
};

export const clearSortPreference = (cacheKey: string): void => {
  const savedSortingOptions = localStorage.getItem(
    ConstantValues.SORTING_OPTIONS_CACHE_KEY,
  );
  const sortingOptions = savedSortingOptions
    ? JSON.parse(savedSortingOptions)
    : {};

  delete sortingOptions[cacheKey];

  localStorage.setItem(
    ConstantValues.SORTING_OPTIONS_CACHE_KEY,
    JSON.stringify(sortingOptions),
  );
};

export const getUseCaseTitles = (
  useCaseIds: string[] | undefined,
  useCases: IUseCase[] | Map<string, string>,
): string => {
  if (!useCaseIds || useCaseIds.length === 0) {
    return "";
  }

  if (useCases instanceof Map) {
    return useCaseIds
      .map((id) => useCases.get(id))
      .filter(Boolean)
      .join(", ");
  }

  const useCaseMap = new Map(useCases.map((uc) => [uc.id, uc.title]));
  return useCaseIds
    .map((id) => useCaseMap.get(id))
    .filter(Boolean)
    .join(", ");
};

export const getKnowledgeComponentsLabel = (
  preselectedIds: string[],
  categories: ICategory[],
): string => {
  return preselectedIds
    .map((id) => {
      for (const cat of categories) {
        const tag = cat.tags.find((t) => t.id === id);
        if (tag) return tag.name;
      }
      return null;
    })
    .filter((name): name is string => !!name)
    .join(", ");
};

export const getNextTab = (currentTab: string): string | null => {
  if (currentTab === TabValues.DETAILS) {
    return TabValues.PROMPT;
  }

  if (currentTab === TabValues.PROMPT) {
    return TabValues.CONFIGURATION;
  }

  return null;
};

export const getPrevTab = (currentTab: string): string | null => {
  if (currentTab === TabValues.CONFIGURATION) {
    return TabValues.PROMPT;
  }

  if (currentTab === TabValues.PROMPT) {
    return TabValues.DETAILS;
  }

  return null;
};
